// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tx","response":"Ux","error":"Vx","disabled":"Wx","buttons":"Xx","feedbackQuestionSection":"Yx","yesNoWrapper":"Zx"};